import React, { useState, useEffect } from 'react';
import {
    WiDaySunny, WiCloudy, WiRain, WiSnow, WiThunderstorm, WiFog
} from 'react-icons/wi';
import { FaLocationArrow } from 'react-icons/fa';
import styles from '../../pages/Account.module.css';

const WeatherWidget = () => {
    const [weather, setWeather] = useState(null);
    const [loading, setLoading] = useState(true);

    // Default location: Paris (can be dynamic later or passed as props)
    const LAT = 48.8566;
    const LON = 2.3522;

    useEffect(() => {
        const fetchWeather = async () => {
            try {
                // Fetch current weather and daily forecast
                const response = await fetch(
                    `https://api.open-meteo.com/v1/forecast?latitude=${LAT}&longitude=${LON}&current=temperature_2m,weather_code,wind_speed_10m&daily=temperature_2m_max,temperature_2m_min&timezone=auto`
                );

                if (!response.ok) throw new Error("Weather fetch failed");

                const data = await response.json();
                setWeather(data);
            } catch (error) {
                console.error("Open-Meteo API Error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchWeather();
    }, []);

    const getWeatherIcon = (code) => {
        // WMO Weather interpretation codes (WW)
        if (code <= 1) return <WiDaySunny size={64} className={styles.weatherIcon} />;
        if (code <= 3) return <WiCloudy size={64} className={styles.weatherIcon} />;
        if (code <= 48) return <WiFog size={64} className={styles.weatherIcon} />;
        if (code <= 69) return <WiRain size={64} className={styles.weatherIcon} />;
        if (code <= 77) return <WiSnow size={64} className={styles.weatherIcon} />;
        if (code <= 99) return <WiThunderstorm size={64} className={styles.weatherIcon} />;
        return <WiDaySunny size={64} className={styles.weatherIcon} />;
    };

    const getWeatherLabel = (code) => {
        if (code === 0) return "Ciel dégagé";
        if (code <= 3) return "Nuageux";
        if (code <= 48) return "Brume";
        if (code <= 69) return "Pluvieux";
        if (code <= 77) return "Neige";
        if (code <= 99) return "Orageux";
        return "Variable";
    };

    if (loading) {
        return (
            <div className={styles.skeleton} style={{ height: '200px', marginBottom: '2rem', borderRadius: '16px' }}></div>
        );
    }

    if (!weather) return null;

    const current = weather.current;
    const daily = weather.daily;
    const todayMax = Math.round(daily.temperature_2m_max[0]);
    const todayMin = Math.round(daily.temperature_2m_min[0]);
    const currentTemp = Math.round(current.temperature_2m);
    const windSpeed = Math.round(current.wind_speed_10m);
    const weatherCode = current.weather_code;

    return (
        <div className={styles.weatherWidget} style={{
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            color: 'white',
            borderRadius: '24px',
            padding: '24px',
            marginBottom: '2rem',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: '0 10px 25px -5px rgba(59, 130, 246, 0.4)'
        }}>
            {/* Background decoration */}
            <div style={{
                position: 'absolute',
                top: '-20px',
                right: '-20px',
                width: '150px',
                height: '150px',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '50%',
                zIndex: 0
            }}></div>

            <div style={{ position: 'relative', zIndex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', opacity: 0.9, marginBottom: '8px', fontSize: '0.9rem', fontWeight: 600 }}>
                        <FaLocationArrow size={12} /> Paris, France
                    </div>
                    <h3 style={{ margin: 0, fontSize: '1.4rem', fontWeight: 800 }}>Météo du Chantier</h3>
                    <p style={{ margin: '4px 0 0', opacity: 0.8, fontSize: '0.9rem' }}>
                        {new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })}
                    </p>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '3rem', fontWeight: 800, lineHeight: 1 }}>{currentTemp}°</div>
                    <div style={{ fontSize: '0.9rem', opacity: 0.9, marginTop: '4px', fontWeight: 600 }}>
                        {todayMin}° / {todayMax}°
                    </div>
                </div>
            </div>

            <div style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '24px',
                background: 'rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(10px)',
                borderRadius: '16px',
                padding: '16px',
                position: 'relative',
                zIndex: 1
            }}>
                <div style={{ marginRight: '16px' }}>
                    {getWeatherIcon(weatherCode)}
                </div>
                <div>
                    <div style={{ fontSize: '1.2rem', fontWeight: 700, marginBottom: '2px' }}>
                        {getWeatherLabel(weatherCode)}
                    </div>
                    <div style={{ fontSize: '0.9rem', opacity: 0.9 }}>
                        Vent: {windSpeed} km/h • Humidité: 65%
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WeatherWidget;
